// TODO update this import when renamed
import { UpdateStatus } from '@hoeks/upcoming-bike-form/src/store/BikeForm/BikeForm.action';
import BikeFormQuery from '@hoeks/upcoming-bike-form/src/query/BikeForm.query';
import { showNotification, updateSubscription } from 'Store/Notification/Notification.action';
import { fetchMutation, fetchQuery, getErrorMessage, QueryDispatcher } from 'SourceUtil/Request';

/** @namespace Hoeks/UpcomingBike-Form/Store/BikeForm/Dispatcher/BikeFormDispatcher */
export class BikeFormDispatcher {
    async subscribeToBike(dispatch, data) {
        // TODO implement
        try {
            fetchQuery(
                BikeFormQuery.subscribeEmailToUpcomingBike(data)
            ).then(result => {
                const {status = 'error', message} = result.subscribeEmailToUpcomingBike;
                if (status == 'error') {
                    dispatch(showNotification('error', message));
                    return;
                }

                dispatch(UpdateStatus(status));
                return;
            });
        } catch (error) {
            dispatch(showNotification('error', error.message))
            return null;
        }
    }

    async updateBikeFormStatus(dispatch, status) {
        try {
            dispatch(UpdateStatus(status));
            return;
        } catch (error) {
            dispatch(showNotification('error', error.message))
            return null;
        }
    }
}

export default new BikeFormDispatcher();
